import { useConfiguration } from "@src/api/configurations/use-configuration";
import {
  currencyFormatter,
  noDecimalCurrencyFormatter,
  noDecimalNumberFormatter,
  numberFormatter,
  numberNoRoundingFormatter,
  percentFormatter,
  percentNoDecimalFormatter,
  percentTwoDecimalFormatter,
} from "@src/features/analytics/dataFormatters";
import { DataType } from "@src/features/analytics/types";

export const useGraphValueFormatter = () => {
  const storeCurrencyConfig = useConfiguration<{
    code: string;
    locale: string;
  }>("shop_currency");

  const returnFunc = ({
    isAxisTick,
    value,
    configDataTypes,
    _index,
    decimalAmountShown = 2,
    shouldShorten = false,
  }: {
    isAxisTick: boolean;
    value: number;
    configDataTypes: DataType[];
    _index?: number;
    decimalAmountShown?: number;
    shouldShorten?: boolean;
  }): string | undefined => {
    const index = _index ?? 0;
    if (storeCurrencyConfig && storeCurrencyConfig.value) {
      if (configDataTypes[index] === "currency") {
        return currencyFormatter(
          value,
          isAxisTick,
          storeCurrencyConfig.value,
          !!decimalAmountShown,
          shouldShorten
        );
      } else if (configDataTypes[index] === "percent") {
        return percentFormatter(value, isAxisTick, storeCurrencyConfig.value);
      } else if (configDataTypes[index] === "percentTwoDecimal") {
        return percentTwoDecimalFormatter(
          value,
          isAxisTick,
          storeCurrencyConfig.value,
          decimalAmountShown
        );
      } else if (configDataTypes[index] === "percentNoDecimal") {
        return percentNoDecimalFormatter(
          value,
          isAxisTick,
          storeCurrencyConfig.value
        );
      } else if (configDataTypes[index] === "numberNoDecimal") {
        return noDecimalNumberFormatter(
          value,
          isAxisTick,
          storeCurrencyConfig.value
        );
      } else if (configDataTypes[index] === "currencyNoDecimal") {
        return noDecimalCurrencyFormatter(
          value,
          isAxisTick,
          storeCurrencyConfig.value
        );
      } else if (configDataTypes[index] === "numberNoRounding") {
        return numberNoRoundingFormatter(
          value,
          isAxisTick,
          storeCurrencyConfig.value
        );
      } else {
        return numberFormatter(value, isAxisTick, storeCurrencyConfig.value);
      }
    }
  };

  return ({
    isAxisTick,
    value,
    configDataTypes,
    _index,
    decimalAmountShown,
    shouldShorten,
  }: {
    isAxisTick: boolean;
    value: number;
    configDataTypes: DataType[];
    _index?: number;
    decimalAmountShown?: number;
    shouldShorten?: boolean;
  }) =>
    returnFunc({
      isAxisTick,
      value,
      configDataTypes,
      _index,
      decimalAmountShown,
      shouldShorten,
    });
};
